<!-- ================= STEPS ================= -->
<div class="px-4 md:px-10 pt-5">
    <div class="relative overflow-x-auto overflow-y-visible">
        <!-- Ligne horizontale -->
        <div class="absolute top-4 left-0 right-0 h-px bg-slate-200"></div>

        <!-- Ligne de steps -->
        <div class="relative flex flex-nowrap items-center min-w-max sm:min-w-0 sm:w-full">
            @for (step of _orderWizardNavigationService.stepList; track $index) {
                <div class="relative flex flex-col items-center px-3 flex-none sm:flex-1">
                    <div class="w-9 h-9 rounded-full flex items-center justify-center text-xs font-semibold transition-all duration-200 relative z-10"
                        [ngClass]="_orderWizardNavigationService.getStepClasses($index)"
                        (click)="_orderWizardNavigationService.selectStep($index)">

                        <!-- DONE -->
                         @if(_orderWizardNavigationService.getStepState($index) === 'done'){
                            <i class="material-symbols-outlined !text-[20px] md:!text-xl text-emerald-600">
                                @switch($index){
                                    @case(0){currency_exchange}
                                    @case(1){storefront}
                                    @case(2){account_circle}
                                    @case(3){fact_check}
                                    @case(4){gavel}
                                    @case(5){receipt_long}
                                }
                            </i>
                         }

                        <!-- CURRENT + TO BE DONE -->
                        @if(_orderWizardNavigationService.getStepState($index) !== 'done') {
                            <ng-container>
                                {{ $index + 1 }}
                            </ng-container>
                        }
                    </div>
                    <div class="min-h-[40px] text-center flex items-center justify-center">
                        {{ step.title | translate }}
                    </div>
                </div>
            }
        </div>
    </div>
</div>